"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initErrorMessage = exports.maxWidgetReadyTime = void 0;
exports.maxWidgetReadyTime = 10000;
exports.initErrorMessage = `We are experiencing some technical difficulties, and can't accept your payment right now. Please try again in a little while.`;
//# sourceMappingURL=constants.js.map